import {Form} from '../classes/Form';
import {mapGetters, mapMutations, mapState} from 'vuex';

export default {
    data () {
        return {
            promoCodeForm: new Form({
                errors: {errors: []},
                promo_code: '',
                phone_number: '',
            }),
        };
    },
    watch: {
        promoCode (val) {
            this.promoCodeForm.promo_code = val;
        },
        'form.phone_number' (val) {
            this.promoCodeForm.phone_number = val;
        }
    },
    methods: {
        ...mapMutations('cart', [
            'setPromoCode',
            'setItems',
        ]),
        applyPromoCode () {
            if (this.promoCodeForm.promo_code) {
                this.promoCodeForm.post('/cart/promo-code')
                    .then(response => {
                        this.setItems(response.cartProducts);
                        this.setPromoCode(this.promoCodeForm.promo_code);
                        window.events.onApplyPromoCode();
                        this.promoCodeForm.errors.clear();
                    }).catch(response => {
                        if (response.errors) {
                            this.removePromoCode();
                        }
                });
            }
        },
        removePromoCode () {
            this.promoCodeForm.post('/cart/delete-promo-code')
                .then(response => {
                    this.setPromoCode('');
                    this.setItems(response.cartProducts);
                });
        }
    },
    computed: {
        ...mapState('cart', ['promoCode', 'form']),
        ...mapGetters('cart', ['promoCodeApplied'])
    }
}
